// src/index.tsx
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import GameHub from './lib/hub/Gamehub';          // ★ 허브 가져오기
import { initGA, logPageView } from './lib/analytics';

initGA();

const App = () => {
  useEffect(() => {
    // 첫 로드 메뉴 페이지뷰
    logPageView();
  }, []);

  return <GameHub />;                     // ★ 메인 허브로 교체
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
